import React from "react";
import { dateRange, initials } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function PhotoCircleSidebarTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug overflow-hidden flex" data-testid="resume-live-preview">
      <div className="w-[34%] p-6 text-white" style={{ backgroundColor: accent }}>
        <div className="w-16 h-16 rounded-full bg-white/20 border-2 border-white/40 flex items-center justify-center text-xl font-bold mb-4">
          {initials(draft.full_name)}
        </div>
        <h1 className="text-lg font-bold leading-tight">{draft.full_name || "Your Name"}</h1>
        {draft.target_role && <p className="text-white/80 text-xs mt-1">{draft.target_role}</p>}
        <div className="mt-5 space-y-1.5 text-[11px] text-white/85">
          {draft.contact_email && <p>✉ {draft.contact_email}</p>}
          {draft.contact_phone && <p>☎ {draft.contact_phone}</p>}
          {draft.location && <p>◎ {draft.location}</p>}
        </div>
        {draft.skills.length > 0 && (
          <div className="mt-5">
            <h2 className="text-[10px] font-bold uppercase tracking-widest text-white/70 mb-2">Skills</h2>
            <div className="space-y-1">
              {draft.skills.map((sk) => <p key={sk} className="text-[11px] text-white/90">• {sk}</p>)}
            </div>
          </div>
        )}
      </div>
      <div className="w-[66%] p-6">
        {draft.summary && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>About Me</h2>
            <p className="text-slate-700 mt-1">{draft.summary}</p>
          </div>
        )}
        {draft.experience.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Experience</h2>
            {draft.experience.map((e, i) => (
              <div key={i} className="mt-2">
                <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mb-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Education</h2>
            {draft.education.map((ed, i) => <p key={i} className="text-slate-700 mt-1"><span className="font-semibold text-slate-800">{ed.degree} {ed.field}</span> — {ed.school}</p>)}
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
